import { createContext } from 'react';
export default createContext({
    startDate: new Date(),
    onStartDateChange: () => [],
    events: [],
    days: 7,
});
